export const FAQS_SOUTH_FLORIDA_POOL_REMODELING_GUIDE: {
  question: string;
  answer: string;
}[] = [
  {
    question: "What is included in a pool remodel?",
    answer:
      "A pool remodel may include the interior finish, waterline tile, coping, pool deck, pavers, verified features, or portions of the surrounding outdoor space. The exact scope varies, so the written proposal should identify every included component.",
  },
  {
    question: "Is resurfacing the same as pool remodeling?",
    answer:
      "Not exactly. Resurfacing focuses primarily on renewing the pool’s interior finish. Remodeling is a broader category that may include resurfacing along with tile, coping, decking, pavers, features, or design changes.",
  },
  {
    question: "Do pool tile and coping have to be replaced during resurfacing?",
    answer:
      "No. Tile and coping should be replaced based on their condition, compatibility with the planned finish, construction sequence, and design goals. Sound components may be able to remain.",
  },
  {
    question: "Should the pool deck be remodeled at the same time as the pool?",
    answer:
      "It depends on the deck’s condition and how it connects to the coping, drainage, elevations, and planned design. Coordinating the work may reduce conflicts, but a sound deck does not need replacement simply because the pool is being resurfaced.",
  },
  {
    question: "What is the biggest cost factor in a pool remodel?",
    answer:
      "There is no single universal factor. The overall scope, pool size and condition, finish selection, tile perimeter, coping, deck square footage, demolition, preparation, access, drainage, and design changes can all affect cost.",
  },
  {
    question: "How long does a pool remodel take?",
    answer:
      "The schedule depends on the project scope, existing conditions, material availability, approvals, weather, access, and sequencing. A focused resurfacing project and a coordinated pool-and-deck remodel should not be expected to follow the same schedule.",
  },
  {
    question: "Can pool remodeling fix cracks or water loss?",
    answer:
      "Not automatically. Cracks and water loss can have several possible causes. The underlying condition should be evaluated before resurfacing or cosmetic remodeling is presented as the solution.",
  },
  {
    question: "How should I compare pool-remodeling proposals?",
    answer:
      "Compare the written scopes line by line. Review preparation, materials, quantities, demolition, tile, coping, deck work, allowances, exclusions, startup responsibilities, and how unforeseen conditions or changes will be handled.",
  },
];

export const TOC_SOUTH_FLORIDA_POOL_REMODELING_GUIDE = [
  {
    id: "what-can-a-pool-remodel-include",
    title: "What Can a Pool Remodel Include?",
  },
  {
    id: "focused-resurfacing-vs-broader-pool-remodeling",
    title: "Focused Resurfacing vs. Broader Pool Remodeling",
  },
  {
    id: "the-five-connected-parts-of-a-pool-remodel",
    title: "The Five Connected Parts of a Pool Remodel",
  },
  {
    id: "three-common-levels-of-pool-remodeling-scope",
    title: "Three Common Levels of Pool-Remodeling Scope",
  },
  {
    id: "what-determines-the-cost-of-a-pool-remodel",
    title: "What Determines the Cost of a Pool Remodel?",
  },
  {
    id: "how-to-plan-the-project-in-the-right-sequence",
    title: "How to Plan the Project in the Right Sequence",
  },
  {
    id: "south-florida-factors-worth-planning-around",
    title: "South Florida Factors Worth Planning Around",
  },
  {
    id: "what-should-a-pool-remodeling-proposal-clarify",
    title: "What Should a Pool-Remodeling Proposal Clarify?",
  },
  {
    id: "pool-remodeling-planning-checklist",
    title: "Pool-Remodeling Planning Checklist",
  },
  { id: "frequently-asked-questions", title: "Frequently Asked Questions" },
];
